import {setToLoading, disableLoading} from "./ui"
import {emailInput} from "./dom";
import {callResetApi} from "./api";

export default function INIT(): void {
    (document.getElementById('reset-pass-form') as HTMLFormElement).addEventListener("submit", resetPass)
}

async function resetPass(event: Event): Promise<void> {
    event.preventDefault();
    setToLoading();

    const email: string = emailInput.value;

    try {
        const response = await callResetApi(email);

        if (response.status === 404) {
            alert("The given email does not exist");
        } else if (response.ok) {
            alert("Reset link has been sent to your email");
            disableLoading();
            window.location.href = "/"
        }
    } catch (e) {
        console.error(e);
        alert("Error resetting password");
        disableLoading();
    }
}